<div class="degree-of-polymerization-container">
    <div class="degree-of-polymerization-item-container">
        <div class="degree-of-polymerization-item-input-container">
            <mat-form-field appearance="outline" class="degree-of-polymerization-form-field">
                <mat-label>Please disclose the degree of polymerization</mat-label>
                <input matInput #degreeOfPolymerizationDisclosureInput [(ngModel)]="degreeOfPolymerizationDisclosure"
                    class="degree-of-polymerization degree-of-polymerization-item-input"
                    (keyup.enter)="updateDegreeOfPolymerizationDisclosure($event)" (keyup.escape)="cancelUpdate()"
                    (blur)="updateDegreeOfPolymerizationDisclosure($event)" />
                <mat-icon matSuffix (mousedown)="clearDegreeOfPolymerizationDisclosureInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
</div>